import React, { useEffect, useRef, useState, useContext } from "react";
import { useTranslation } from "react-i18next";
import toast from "react-hot-toast";
import AppContext from "../context/AppContext";
import ConfirmButton from "./ConfirmButton";

export default function DirectsOptions() {
    const { t } = useTranslation();
    const { tanksdata, showDirects, updateLoading } = useContext(AppContext);


    const closeShare = () => {
        showDirects(false);
    }

    useEffect(() => {
        window.scrollTo(0, 0);
        document.body.classList.add('overflow-y-hidden');
        return () => {
            document.body.classList.remove('overflow-y-hidden');
        };
    }, []);

    const items = [
        { cost: 25, title: 'HBAR', level: 1, ctxflix: "basic", unilevel: 1 },
        { cost: 100, title: 'SUI', level: 2, ctxflix: "intermediate", unilevel: 2 },
        { cost: 250, title: 'TRX', level: 3, ctxflix: "advanced", unilevel: 3 },
        { cost: 500, title: 'DOGE', level: 4, max: "2.5X", ctxflix: "completed", unilevel: 4, signals: true },
        { cost: 1000, title: 'SOL', level: 5, max: "2.5X", ctxflix: "completed", unilevel: 5, signals: true, copy: true },
        { cost: 2500, title: 'BNB', level: 6, max: "2.5X", ctxflix: "completed", unilevel: 6, signals: true, copy: true },
        { cost: 5000, title: 'ETH', level: 7, max: "3X", ctxflix: "completed", unilevel: 7, signals: true, copy: true },
        { cost: 10000, title: 'BTC', level: 8, max: "3X", ctxflix: "completed", unilevel: 8, signals: true, copy: true },
    ];

    return (
        <>
            <div className="w-screen absolute h-full" style={{ zIndex: "100", backgroundColor: "#00000091" }}>
                <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2  custom-button-shadow-two rounded p-10 bg-zinc-800 w-11/12 lg:w-3/5">
                    <div className="flex justify-end cursor-pointer" onClick={() => closeShare()}>
                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" className="size-6 text-blue-300 text-end">
                            <path stroke-linecap="round" stroke-linejoin="round" d="M6 18 18 6M6 6l12 12" />
                        </svg>
                    </div>
                    <div className="flex flex-col w-full justify-center items-center">
                        <h2 className="text-white">{tanksdata?.name || "Loading.."}</h2>
                        <h2 className="text-white">{t("_LOGIN._EMAIL")}: {tanksdata?.email || "Loading.."}</h2>
                        <h2 className="text-white">{t("_REGISTER._WHATSAPP")}: {tanksdata?.whatsapps || "Loading.."}</h2>
                        <h2 className="text-white">{t("_DASHBOARD._STATUS")}: {tanksdata?.active === "1" ? t("_DASHBOARD._STATUS_ACTIVE") : t("_DASHBOARD._STATUS_INACTIVE")}</h2>
                    </div>
                </div>
            </div>
        </>
    )
}
